/**
 * Formats an array into a readable string list with optional Oxford comma
 * Example: ['apple', 'banana', 'orange'] => 'apple, banana, and orange'
 */
export function formatListWithOxfordComma(items: string[]): string {
    if (items.length === 0) return "";
    if (items.length === 1) return items[0];

    const lastItem = items[items.length - 1];
    const itemsExceptLast = items.slice(0, -1);
    const useOxfordComma = items.length > 2;

    return `${itemsExceptLast.join(", ")}${useOxfordComma ? "," : ""} and ${lastItem}`;
}
